<template>
  <div class="layout-topbar tw:flex tw:justify-between tw:pb-[25px] tw:pt-[64px] tw:px-[16px] tw:w-full tw:max-w-[430px] tw:mx-auto tw:h-[113px] tw:flex-shrink-0" style="background: rgba(245, 245, 247, 0.25); backdrop-filter: blur(37.5px);">
    <div class="layout-topbar-logo-container tw:self-center">
      <router-link to="/" class="layout-topbar-logo">
        <Image src="/images/logos/Medicia-logo.svg" alt="Medicia"/>
      </router-link>
    </div>

    <div class="layout-topbar-items-container tw:self-center tw:flex tw:items-center tw:gap-x-[36px] tw:relative">
      <!-- Progress Circle -->
<!--      <div class="tw:relative">-->
<!--        <div class="tw:relative tw:flex tw:items-center tw:justify-center">-->
<!--          <svg class="tw:absolute" width="40" height="40" viewBox="0 0 40 40">-->
<!--            <circle-->
<!--              cx="20"-->
<!--              cy="20"-->
<!--              r="18.25"-->
<!--              stroke="#F5F5F7"-->
<!--              stroke-width="3.5"-->
<!--              fill="transparent"-->
<!--            />-->
<!--            <circle-->
<!--              v-if="score > 0"-->
<!--              cx="20"-->
<!--              cy="20"-->
<!--              r="18.25"-->
<!--              stroke="#20BF6B"-->
<!--              stroke-width="3.5"-->
<!--              fill="transparent"-->
<!--              stroke-dasharray="100"-->
<!--              :stroke-dashoffset="100 - score"-->
<!--              stroke-linecap="round"-->
<!--              transform="rotate(-90 20 20)"-->
<!--            />-->
<!--          </svg>-->
<!--          <div class="tw:relative tw:z-[1] tw:text-white tw:text-[13px] tw:font-[700] tw:text-center">{{ score }}</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="tw:relative tw:inline-block">
        <i
          class="pi pi-equals"
          style="font-size: 24px; font-weight: 500; color: black; cursor: pointer"
          @click="toggleLeftDrawer"
        ></i>
        <span
          class="tw:absolute tw:top-0 tw:-right-[3px] tw:w-[10px] tw:h-[10px] tw:bg-[#EB3B5A] tw:rounded-full"
          aria-hidden="true"
        ></span>
      </div>
    </div>
  </div>
</template>

<script setup>
// 1. Import necessary components
import { ref, onMounted } from 'vue';
import { useAppStore } from '@/stores/app-store';
import { useLoadingDelay } from '@/composables/useLoadingDelay';
import { useEventBus } from '@/composables/useEventBus';

// 2. Use
const { toggleLeftDrawer } = useAppStore();
const { loading, finish } = useLoadingDelay();
const { onEvent } = useEventBus();

// 3. Define a reactive variable
const score = ref(0);

// 4. Define methods or computed properties if needed
// 4.1 Define methods
const fetchScore = async () => {
  const start = Date.now();
  // const trackerService = (await import('@/shared/services/tracker.service')).default;
  // const res = await trackerService.findHPSCard();
  // const hps = res?.healthProgressScore;
  // score.value = hps?.score ?? 0;
  score.value = 0;
  finish(start);
};

// Expose refresh method for parent components
const refreshScore = () => {
  fetchScore();
};

// 5. VueJS Hooks
onMounted(() => {
  fetchScore();
  onEvent('update-topbar-score', fetchScore);
});

defineExpose({ refreshScore, loading });
</script>

<style scoped>
</style>
